/*
  lv-smooth.js (V51, 30 okt 2026). Rustiger gedrag op de hele site, zonder iets aan vorm, kleur of tekst te veranderen.
  Jens (30 okt 2026): "alles moet smooth werken en niet zo plots verspringen ... alles moet vloeiend scrollen en
  openen en geleidelijk laden". De CSS staat in snippets/lv-smooth.liquid. Dit script past geen DOM-structuur van
  andere componenten aan: het kijkt mee (MutationObserver, ResizeObserver) en speelt korte animaties af met de Web
  Animations API. Valt die weg, dan werkt alles zoals voorheen, alleen zonder overgang.
  1. --lv-sbw: breedte van een vaste schuifbalk, voor de CSS die het opzij springen bij openen van lades voorkomt.
  2. Filtervak onder een chip: zacht openen, sluiten en wisselen; staat het vak in de pagina, dan schuift de inhoud
     eronder geleidelijk mee in plaats van in een keer honderden pixels.
  3. Producten die later in het grid komen (oneindig scrollen): korte fade. Bij filters (31 okt 2026) doet
     assets/lv-filter-stage.js de overgang zelf; die kaarten (__lvLive) slaat dit script over.
  4. Uitklapmenu op de computer: de hoogte gaat geleidelijk mee bij wisselen tussen menu's.
  5. Winkelwagen: de laadweergave na Add to cart vervaagt in plaats van in een keer te verdwijnen.
  6. De rij filterchips verschijnt bij het laden met een korte fade in de al gereserveerde ruimte.
*/
(function () {
  var de = document.documentElement;
  var still = !window.matchMedia || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canAnim = !still && typeof Element !== 'undefined' && 'animate' in Element.prototype;
  var EASE = 'cubic-bezier(.2, 0, 0, 1)';

  /* 1. Schuifbalkbreedte, alleen meten als de pagina niet vastgezet is. */
  function locked() { return de.hasAttribute('scroll-lock') || de.classList.contains('lv-pop-lock') || de.classList.contains('hv-pop-lock') || document.body && document.body.style.position === 'fixed'; }
  function sbw() {
    if (locked()) return;
    var w = Math.max(0, window.innerWidth - de.clientWidth);
    de.style.setProperty('--lv-sbw', (w > 30 ? 0 : w) + 'px');
  }
  sbw();
  window.addEventListener('resize', sbw, { passive: true });
  window.addEventListener('load', sbw);
  window.addEventListener('scroll', sbw, { passive: true, once: true }); // pagina kan na het laden pas lang genoeg worden

  if (!canAnim) return;

  var lastClick = { t: 0, el: null };
  document.addEventListener('click', function (e) { lastClick = { t: Date.now(), el: e.target instanceof Element ? e.target : null }; }, true);
  function recentClick(sel, ms) { return lastClick.el && Date.now() - lastClick.t < (ms || 600) && lastClick.el.closest(sel); }

  function inFlow(el) { var p = getComputedStyle(el).position; return p !== 'absolute' && p !== 'fixed'; }
  // Natuurlijke hoogte, ook als er net een hoogte-animatie loopt (offsetHeight is dan de tussenstand).
  function natH(el) { var cs = getComputedStyle(el); return el.scrollHeight + parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth); }
  function outerH(el) { var cs = getComputedStyle(el); return natH(el) + parseFloat(cs.marginTop) + parseFloat(cs.marginBottom); }

  /* 2. Filtervak onder een chip (sections/lv-collection-head.liquid maakt .lv-cp en zet hidden). */
  var cp = new WeakMap(); // el -> { open, h, chip }
  function openChip() { var c = document.querySelector('.lv-chip[aria-expanded="true"]'); return c ? c.getAttribute('data-lv-chip') : null; }
  function animHeight(el, from, to) {
    el.style.overflow = 'hidden';
    var a = el.animate([{ height: from + 'px' }, { height: to + 'px' }], { duration: 220, easing: EASE });
    var done = function () { el.style.overflow = ''; };
    a.onfinish = done; a.oncancel = done;
  }
  function collapseAfter(el, h) {
    // Het vak is al weg (display: none). Een lege ruimte van dezelfde hoogte krimpt in 200 ms naar 0, zodat de
    // producten eronder geleidelijk omhoog schuiven. Daarna is de ruimte weg; er blijft niets achter in de pagina.
    if (!el.parentNode || h < 8) return;
    var s = document.createElement('div');
    s.setAttribute('aria-hidden', 'true');
    s.className = 'lv-s-spacer';
    s.style.cssText = 'height:' + h + 'px;margin:0;padding:0;border:0;pointer-events:none;';
    el.parentNode.insertBefore(s, el.nextSibling);
    var a = s.animate([{ height: h + 'px' }, { height: '0px' }], { duration: 200, easing: EASE });
    var rm = function () { if (s.parentNode) s.parentNode.removeChild(s); };
    a.onfinish = rm; a.oncancel = rm;
    setTimeout(rm, 600);
  }
  function checkCp(el) {
    var st = cp.get(el) || { open: false, h: 0, chip: null };
    var open = !el.hidden && el.isConnected && el.offsetParent !== null;
    var chip = openChip();
    if (open && !st.open) {
      // Openen: in de pagina de hoogte van 0 laten groeien; als zwevend vak doet de CSS-animatie het werk.
      if (inFlow(el)) animHeight(el, 0, natH(el));
    } else if (open && st.open && chip !== st.chip && st.chip !== null) {
      // Wisselen van chip: de inhoud is opnieuw opgebouwd. Korte fade; in de pagina gaat de hoogte geleidelijk mee.
      el.animate([{ opacity: 0, transform: 'translateY(-4px)' }, { opacity: 1, transform: 'none' }], { duration: 200, easing: EASE });
      if (inFlow(el) && Math.abs(natH(el) - st.h) > 4) animHeight(el, st.h, natH(el));
    } else if (!open && st.open) {
      // Sluiten. Niet na "Show N items": dan vervangt het thema de producten en mag er niets tussen staan.
      if (st.flow && !recentClick('.lv-cp__show, [data-lv-cp="show"]', 800)) collapseAfter(el, st.outer);
    }
    cp.set(el, { open: open, h: open ? natH(el) : 0, outer: open ? outerH(el) : 0, flow: open ? inFlow(el) : false, chip: open ? chip : null });
  }
  var cpObs = new MutationObserver(function (ms) {
    var set = new Set();
    ms.forEach(function (m) {
      if (m.type === 'attributes') { var t = m.target; if (t.classList && t.classList.contains('lv-cp')) set.add(t); else if (t.classList && t.classList.contains('lv-chip')) document.querySelectorAll('.lv-cp').forEach(function (x) { set.add(x); }); }
      else m.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.classList.contains('lv-cp')) set.add(n); else if (n.querySelectorAll) n.querySelectorAll('.lv-cp').forEach(function (x) { set.add(x); }); } });
    });
    // Direct, nog voor het volgende beeld: renderPanel zet inhoud, hidden en chipstatus in één klik-afhandeling, dus de
    // eindtoestand staat er al. Wachten op een frame gaf een flits van het volledig open vak.
    set.forEach(checkCp);
  });

  /* 3. Producten die later in het grid komen. */
  var ready = false;
  function fadeCards(list) {
    var vh = window.innerHeight, i = 0;
    list.forEach(function (li) {
      var r = li.getBoundingClientRect();
      if (r.bottom < -50 || r.top > vh + 400) return; // buiten beeld: geen animatie nodig
      li.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], { duration: 260, delay: Math.min(i++, 7) * 35, easing: EASE, fill: 'backwards' });
    });
  }

  /* 5. Laadweergave van de winkelwagen (hv-mobile.liquid voegt .hv-atc-pending toe en haalt hem weer weg). */
  function ghost(node, parent) {
    if (!parent || !parent.isConnected || !(node instanceof HTMLElement)) return;
    var g = node.cloneNode(true);
    g.classList.add('lv-s-ghost');
    g.setAttribute('aria-hidden', 'true');
    g.style.pointerEvents = 'none';
    parent.appendChild(g);
    var a = g.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 220, easing: 'ease-out', fill: 'forwards' });
    var rm = function () { if (g.parentNode) g.parentNode.removeChild(g); };
    a.onfinish = rm; a.oncancel = rm;
    setTimeout(rm, 800);
  }

  /* 6. De rij chips wordt door het thema opgebouwd; eerste keer zacht laten verschijnen. */
  var chipsShown = false;
  function firstChips(n) {
    if (chipsShown) return;
    var row = n.classList && (n.classList.contains('lv-chips') || n.classList.contains('lv-topbar')) ? n : n.querySelector && n.querySelector('.lv-topbar, .lv-chips');
    if (!row) return;
    chipsShown = true;
    if (performance.now() > 8000) return;
    row.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 220, easing: 'ease-out' });
  }

  var mainObs = new MutationObserver(function (ms) {
    var cards = [];
    ms.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (!chipsShown) firstChips(n);
        if (!ready) return;
        // Kaarten van het direct doorvoeren van filters (assets/lv-filter-stage.js, __lvLive) animeert dat script zelf
        if (n.__lvLive) return;
        if (n.classList.contains('product-grid__item')) cards.push(n);
        else if (n.querySelectorAll && (n.tagName === 'UL' || n.classList.contains('product-grid') || n.id === 'ResultsList' || n.classList.contains('main-collection-grid'))) n.querySelectorAll('.product-grid__item').forEach(function (x) { if (!x.__lvLive) cards.push(x); });
      });
      m.removedNodes.forEach(function (n) {
        if (n.nodeType === 1 && n.classList.contains('hv-atc-pending') && !n.classList.contains('lv-s-ghost')) ghost(n, m.target);
      });
    });
    if (cards.length) fadeCards(cards);
  });

  /* 4. Uitklapmenu op de computer (sections/rok-header-mega.liquid). */
  function megaInit() {
    var box = document.querySelector('.rok-mega-outer-container');
    if (!box || !('ResizeObserver' in window)) return;
    var lastH = 0, openSince = 0, switching = false, anim = null;
    new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        if (m.target === box) { if (box.classList.contains('is-open')) { if (!openSince) openSince = Date.now(); } else openSince = 0; return; }
        // Alleen het moment dat een andere inhoud actief wordt (niet de latere klasse animate-in)
        var wasActive = /(^|\s)active(\s|$)/.test(m.oldValue || '');
        if (!wasActive && m.target.classList.contains('active') && box.classList.contains('is-open') && openSince && Date.now() - openSince > 350) switching = true;
      });
    }).observe(box, { attributes: true, attributeFilter: ['class'], attributeOldValue: true, subtree: true });
    new ResizeObserver(function () {
      if (anim) return; // tijdens de eigen animatie verandert de hoogte elk frame; dat is geen nieuwe wissel
      var h = box.offsetHeight;
      if (switching && lastH > 0 && Math.abs(h - lastH) > 2 && window.innerWidth > 768) {
        anim = box.animate([{ height: lastH + 'px' }, { height: h + 'px' }], { duration: 220, easing: EASE });
        var end = function () { anim = null; lastH = box.offsetHeight; };
        anim.onfinish = end; anim.oncancel = end;
      } else lastH = h;
      switching = false;
    }).observe(box);
  }

  function start() {
    if (document.querySelector('.lv-chips, .lv-topbar')) chipsShown = true; // al gebouwd voordat dit script liep
    cpObs.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden', 'aria-expanded'] });
    mainObs.observe(document.body, { subtree: true, childList: true });
    megaInit();
    // Producten die bij het laden van de pagina al in de HTML staan, krijgen geen animatie.
    setTimeout(function () { ready = true; }, 1200);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
